// Link do cardápio que a CLEO manda no WhatsApp: `?r=<token>` identifica a conversa.
// O cardápio guarda o token por 3h e avisa quando o cliente abre e mexe no carrinho;
// o pedido leva o token, pra venda contar mesmo saindo em outro cadastro.
// O mesmo token traz de volta o que a CLEO anotou na conversa (`buscarComanda`),
// pra o carrinho já abrir montado.
import axios from "axios";

const CHAVE = "nucleo_link_conversa";
const VALIDADE_MS = 3 * 60 * 60 * 1000;
const TOKEN_RE = /^[A-Za-z0-9]{6,20}$/;

function ler() {
  try {
    const salvo = JSON.parse(localStorage.getItem(CHAVE) || "null");
    return salvo && Date.now() - salvo.em < VALIDADE_MS ? salvo : null;
  } catch {
    return null;
  }
}

// Lê `?r=` da URL (antes do #) na abertura. Devolve o token novo, se veio um.
export function capturarToken() {
  let token = null;
  try {
    token = new URLSearchParams(window.location.search).get("r");
  } catch {
    token = null;
  }
  if (!token || !TOKEN_RE.test(token)) return null;
  try { localStorage.setItem(CHAVE, JSON.stringify({ token, em: Date.now() })); } catch { /* sem storage */ }
  return token;
}

export function tokenDaConversa() {
  return ler()?.token || null;
}

export function esquecerToken() {
  try { localStorage.removeItem(CHAVE); } catch { /* sem storage */ }
}

export function avisar(tipo, carrinho) {
  const token = tokenDaConversa();
  if (!token) return;
  const corpo = { token, tipo };
  if (carrinho) {
    corpo.itens = carrinho.itens;
    corpo.total = carrinho.total;
  }
  axios.post("/api/public/recuperador/evento", corpo).catch(() => {});
}

// Os itens que a CLEO anotou na conversa deste link, no formato do pedido
// (o mesmo do "Peça de novo"). Lista vazia quando não há pedido anotado.
export async function buscarComanda(token) {
  if (!token || !TOKEN_RE.test(token)) return [];
  try {
    const res = await axios.get("/api/public/recuperador/comanda", { params: { token } });
    return Array.isArray(res.data?.itens) ? res.data.itens : [];
  } catch {
    return [];
  }
}
